<template>
    <vuex-currency-input
        :getter="() => model"
        :setter="value => setValue(value)"
        variant="underlined"
        :disabled="isDisabled"
        :name="`${params.data.productKey}-currency-input`"
        density="compact"
    />
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    data() {
        return {
            model: null,
        };
    },
    computed: {
        isDisabled() {
            const data = this.params.data;
            return this.params.isDisabled(data) || this.params.context?.isReadOnly();
        },
    },
    created() {
        this.model = this.params.value;
    },

    methods: {
        setValue(value) {
            this.model = value;
            const params = {
                oldValue: this.params.value,
                newValue: value,
                data: this.params.data,
                colDef: {
                    field: this.params.colDef.field,
                },
            };
            this.$nextTick(() => {
                this.params.onInputChange(params);
            });
        },
    },
});
</script>
